import state from './invoiceState'
import mutations from './invoiceMutations'
import actions from './invoiceActions'
import getters from './invoiceGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
